import { useCallback } from "react";
import { CardService } from "services";
import CardList from "./list";

const CardNewList = () => {

  const fetch = useCallback((page: number, search: string | undefined) => CardService.cardsAll({ page: page ?? 0, search: search, crm: false }), []);

  return <CardList fetch={fetch} />;
}

export default CardNewList;